import { useContext, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FuseUtils from '@fuse/utils/FuseUtils';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogBaseV1 } from 'src/app/@core/forms/dialog/@dialogBaseV1';
import { DialogHeaderContent } from 'src/app/@core/forms/controls/dialogHeaderContent';
import { DomainContext } from 'src/app/@core/@contexts/domain.context';
import { isUoN } from 'src/app/@core/common';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { TextInput } from 'src/app/@core/forms/controls/textInput';
import { TextArea } from 'src/app/@core/forms/controls/textArea';

/**
 *
 */
export class SalespersonAddDialogController extends DialogBaseV1 {
  /**
   *
   * @param {*} context
   */
  constructor(context) {
    super(context, 'salespersonAddDialogDataObj');
  }

  /**
   *
   * @returns
   */
  items = () => this.model().items;

  /**
   *
   * @param {*} data
   */
  hide = (data) => {
    const store = { ...this.store() };
    store.salespersonAddDialogDataObj.visible = false;
    this.context.setStore(store);
    this.resolve(data);
  };

  /**
   *
   * @returns
   */
  show = async () => {
    try {
      this.spinner().show();

      const store = { ...this.store() };
      this.context.setStore(store);

      return super.show();
    } catch (err) {
      console.log(err);
    } finally {
      this.spinner().hide();
    }
  };
  getRetailers = () => {
    const store = { ...this.store() };
    return store.orderAddDialogDataObj.retailers;
  };
}

/**
 *
 * @param {*} props
 * @returns
 */
export const SalespersonAddDialog = (props) => {
  const { salesPersonAddDialogController, api, spinner } =
    useContext(DomainContext);
  const frmModel = useForm({ mode: 'onChange', defaultValues: {} });
  const { control, getValues, handleSubmit, reset } = frmModel;

  /**
   * 
   * @param {*} salesperson 
   */
  const onClose = salesperson => {
    salesPersonAddDialogController.hide(salesperson);
    reset();
  };

  /**
   *
   */
  const onSubmit = async () => {

    let salesperson = null;

    try {

      spinner.show();

      const obj = getValues();
      if (!isUoN(obj.retailer)) obj.retailerID = obj.retailer.id;
      obj.isActive = true;
      obj.dateCreated = new Date();
      salesperson = await api.contactApi.addSalesPerson(obj);

    } catch (err) { console.log(err); }
    finally { spinner.hide(); }

    onClose(salesperson);

  };

  return (
    <Dialog
      fullScreen
      style={{ margin: 'auto', maxWidth: 600, maxHeight: 500, zIndex: 9000 }}
      open={salesPersonAddDialogController.visible()}
      onClose={() => onClose(null)}
      scroll='paper'
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
    >
      <DialogTitle id='scroll-dialog-title'>
        <DialogHeaderContent title='Create Salesperson' onClose={() => onClose(null)} />
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} className='dialog-form_inner'>
        <DialogContent dividers={true} style={{ padding: 10 }}>
          <FormProvider {...frmModel}>
            <div>
              <div className='flex'>
                <TextInput
                  id='firstName'
                  label='First Name'
                  control={control}
                  rules={{ required: 'First Name is required' }}
                />
                <TextInput
                  id='lastName'
                  label='Last Name'
                  control={control}
                  rules={{ required: 'Last Name is required' }}
                />
              </div>
              <div className='flex'>
                <TextInput
                  id='middleName'
                  label='Middle Name'
                  control={control}
                />
                <TextInput id='title' label='Title' control={control} />
              </div>
              <div className='flex'>
                <div style={{ width: '50%', marginLeft: 5, marginRight: 10 }}>
                  <Controller
                    name='retailer'
                    control={control}
                    rules={{
                      required: 'Please select retailer',
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        {...field}
                        value={
                          field.value
                            ? salesPersonAddDialogController
                                .getRetailers()
                                .find((option) => {
                                  return field.value.itemID === option.itemID;
                                }) ?? null
                            : null
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.itemID === (value ? value.itemID : null)
                        }
                        disablePortal
                        id='retailer'
                        className='mt-8'
                        fullWidth
                        options={salesPersonAddDialogController.getRetailers()}
                        onChange={(e, data) => {
                          field.onChange(data);
                        }}
                        getOptionLabel={(x) => x.name}
                        renderOption={(props, option) => (
                          <li {...props} key={option.itemID}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            helperText={error ? error.message : null}
                            error={!!error}
                            className=''
                            label='Retailer'
                            size='small'
                          />
                        )}
                      />
                    )}
                  />
                </div>
                <div style={{ width: '50%', marginRight: 10 }}>
                  <TextInput id='email' label='Email' control={control} />
                </div>
              </div>
              <div className='flex -mx-4'>
                <TextArea
                  id='contactNotes'
                  label='Comments'
                  control={control}
                />
              </div>
            </div>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' onClick={() => onClose(null)}>
            Cancel
          </Button>
          <Button variant='contained' color='secondary' type='submit'>
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
